import { createContext, useContext } from 'react';

interface AppFeatureContextType {
  newMastheadEnabled: boolean;
}

const AppFeatureContext = createContext<AppFeatureContextType | undefined>(
  undefined,
);

export function AppFeatureProvider({
  children,
  value,
}: {
  children: React.ReactNode;
  value: AppFeatureContextType;
}) {
  return (
    <AppFeatureContext.Provider value={value}>
      {children}
    </AppFeatureContext.Provider>
  );
}

export const useAppFeature = () => {
  const context = useContext(AppFeatureContext);
  if (context === undefined) {
    throw new Error('useAppFeature must be used within a AppFeatureProvider');
  }
  return context;
};
